import dataLayer from './utils/dataLayer';
import {
  SEARCH_PAGE_TITLE,
  COMPARISON_PAGE_TITLE,
  DETAIL_PAGE_TITLE,
  PURCHASE_PAGE_TITLE,
  HOME_PAGE_TITLE,
} from './constants';


export const removeDuplicates = (arr) => {
  const uniqueArray = [];
  for (let i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) {
      uniqueArray.push(arr[i]);
    }
  }
  return uniqueArray;
};

export const groupByCategory = (benefits) => {
  const groupedObj = [];
  benefits.forEach((benefit) => {
    if (groupedObj[benefit.category_name] === undefined) groupedObj[benefit.category_name] = [];
    groupedObj[benefit.category_name].push({ ...benefit, opened: false });
  });

  return groupedObj;
};

export const toggleAccordion = (accordionList, code) => {
  const newAccordionList = {};
  Object.keys(accordionList).forEach((key) => {
    newAccordionList[key] = accordionList[key].map((item) => ({
      ...item,
      opened: item.code === code ? !item.opened : false,
    }));
  });

  return newAccordionList;
};

export const getUrlParams = (url) => {
  let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

  if (!queryString) return {};

  const obj = {};

  [queryString] = queryString.split('#');

  const param = queryString.split('&');

  for (let i = 0; i < param.length; i += 1) {
    const paramName = param[i].substr(0, param[i].indexOf('=')).toLowerCase();
    const paramValue = param[i].substr(param[i].indexOf('=') + 1);

    obj[paramName] = paramValue;
  }

  return obj;
};

export function detectCardBrand(number) {
  const num = number.replace(/\D/g, '');

  if (/^4/.test(num)) return 'visa';
  if (/^5[1-5]/.test(num) || /^2(2[2-9]|[3-6]|7[01]|720)/.test(num)) return 'mastercard';
  if (/^3[47]/.test(num)) return 'amex';
  if (/^3(0[0-5]|[68])/.test(num)) return 'diners';
  if (/^(606282|3841)/.test(num)) return 'hiper';
  if (/^(4011|4312|4389|4514|4573|4576|5041|5066|5067|509|6277|6362|6363|650|6516|6550)/.test(num)) return 'elo';
  return '';
}

export const validateCreditCard = (brand, number, field) => {
  let valid = true;
  const num = number.replace(/\s/g, '').toString();

  const regexBrands = {
    amex: {
      number: [/^(34|37)\d+$/, /^3[47][0-9]{13}$/gm],
      cvv: /^\d{4}$/,
    },
    visa: {
      number: [
        /^4\d{12}(\d{3})?$/gm,
        /^(((40117[8-9]|431274|438935|451416|457393|45763[1-2]|506(699|7[0-6][0-9]|77[0-8])|509\d{3}|504175|627780|636297|636368|65003[1-3]|6500(3[5-9]|4[0-9]|5[0-1])|6504(0[5-9]|[1-3][0-9])|650(4[8-9][0-9]|5[0-2][0-9]|53[0-8])|6505(4[1-9]|[5-8][0-9]|9[0-8])|6507(0[0-9]|1[0-8])|65072[0-7]|6509(0[1-9]|1[0-9]|20)|6516(5[2-9]|[6-7][0-9])|6550([0-1][0-9]|2[1-9]|[3-4][0-9]|5[0-8]))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})$/g,
      ],
      cvv: /^\d{3}$/,
    },
    mastercard: {
      number: /^(?:5[1-5]\d{2}|222[1-9]|22[3-9]\d|2[3-6]\d{2}|27[01]\d|2720)\d{12}$/gm,
      cvv: /^\d{3}$/,
    },
    elo: {
      number: [
        /^4\d{12}(\d{3})?$/gm,
        /^(((40117[8-9]|431274|438935|451416|457393|45763[1-2]|506(699|7[0-6][0-9]|77[0-8])|509\d{3}|504175|627780|636297|636368|65003[1-3]|6500(3[5-9]|4[0-9]|5[0-1])|6504(0[5-9]|[1-3][0-9])|650(4[8-9][0-9]|5[0-2][0-9]|53[0-8])|6505(4[1-9]|[5-8][0-9]|9[0-8])|6507(0[0-9]|1[0-8])|65072[0-7]|6509(0[1-9]|1[0-9]|20)|6516(5[2-9]|[6-7][0-9])|6550([0-1][0-9]|2[1-9]|[3-4][0-9]|5[0-8]))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})$/g,
      ],
      cvv: /^\d{3}$/,
    },
    diners: {
      number: [/^(?:5[1-5])\d{14}$/gm, /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/gm],
      cvv: /^\d{3}$/,
    },
    hiper: {
      number: /^(606282\d{10}(\d{3})?)|(3841\d{15})$/gm,
      cvv: /^\d{3}$/,
    },
  };

  if (regexBrands[brand][field].length > 1) {
    if (!regexBrands[brand][field][0].test(num) && !regexBrands[brand][field][1].test(num)) valid = false;
  } else {
    if (!regexBrands[brand][field].test(num)) valid = false;
  }

  return valid;
};

export const maskCashTransferAgency = (bank) => {
  switch (bank.slug) {
    case 'banco-do-brasil':
      return [/\d/, /\d/, /\d/, /\d/, '-', /\d/];
    default:
      return [/\d/, /\d/, /\d/, /\d/];
  }
};

export const maskCashTransferAccount = (bank) => {
  switch (bank.slug) {
    case 'santander':
      return [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/];
    case 'inter':
      return [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/];
    default:
      return [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/];
  }
};

export const updatePurchaseSummaryData = (state) => {
  const checkAvailablePaymentMethods = (oldState) => {
    const paymentMethods = [...oldState.paymentMethods];

    const safetypayMethod = paymentMethods.find((element) => element.slug === 'safetypay');
    const boletoMethod = paymentMethods.find((element) => element.slug === 'boleto');

    if (safetypayMethod) {
      if (parseFloat(oldState.purchaseSummary.total) < parseFloat(oldState.safetypay.min_value)) {
        paymentMethods.find((element) => element.slug === 'safetypay').available = false;
      } else {
        paymentMethods.find((element) => element.slug === 'safetypay').available = oldState.safetypay.available;
      }
    }

    if (boletoMethod) {
      if (parseFloat(oldState.purchaseSummary.total) < parseFloat(oldState.boleto.min_value)) {
        paymentMethods.find((element) => element.slug === 'boleto').available = false;
      } else {
        paymentMethods.find((element) => element.slug === 'boleto').available = oldState.boleto.available;
      }
    }

    return {
      ...oldState,
      paymentMethods,
    };
  };

  const selectedPaymentMethod = (paymentMethods) => {
    for (const pm in paymentMethods) {
      if (paymentMethods[pm].selected) {
        return paymentMethods[pm].id;
      }
    }
  };

  if (!state.plans || state.plans.length === 0) return { ...state };

  const { paymentMethods, alert } = state;

  const purchaseSummary = {
    ...state.purchaseSummary,
    child: { qte: 0, price: 0 },
    adult: { qte: 0, price: 0 },
    elder: { qte: 0, price: 0 },
    invalid: { qte: 0, price: 0 },
  };

  state.insuredForms.forEach((insured) => {
    if (insured.birth_date.match(/[0-3]\d\/[0-1]\d\/[1-2]\d\d\d/)) {
      const splDate = insured.birth_date.split('/');
      const fmtBirth = `${splDate[2]}-${splDate[1]}-${splDate[0]}`;
      const birthDate = new Date(fmtBirth);
      const ref = new Date(state.quotationParams.departure_date);
      let age = 0;
      if (
        (birthDate.getUTCDate() <= ref.getUTCDate() && birthDate.getUTCMonth() === ref.getUTCMonth()) ||
        birthDate.getUTCMonth() < ref.getUTCMonth()
      ) {
        age = ref.getUTCFullYear() - birthDate.getUTCFullYear();
      } else {
        age = ref.getUTCFullYear() - birthDate.getUTCFullYear() - 1;
      }

      // invalid
      if (age < state.plans[0].child.min_age || age > state.plans[0].elder.max_age) purchaseSummary.invalid.qte += 1;
      // child
      else if (age >= state.plans[0].child.min_age && age <= state.plans[0].child.max_age) {
        purchaseSummary.child.qte += 1;
        purchaseSummary.child.price = purchaseSummary.child.qte * state.plans[0].child.price;
      }
      // elder
      else if (state.plans[0].elder.max_age <= state.plans[0].elder.min_age && age > state.plans[0].elder.max_age) {
        purchaseSummary.elder.qte += 1;
        purchaseSummary.elder.price = purchaseSummary.elder.qte * state.plans[0].elder.price;
        insured.elder = true;
      } else if (
        state.plans[0].elder.max_age - state.plans[0].elder.min_age <= 1 &&
        age > state.plans[0].elder.max_age
      ) {
        purchaseSummary.elder.qte += 1;
        purchaseSummary.elder.price = purchaseSummary.elder.qte * state.plans[0].elder.price;
        insured.elder = true;
      } else if (age >= state.plans[0].elder.min_age && age <= state.plans[0].elder.max_age) {
        purchaseSummary.elder.qte += 1;
        purchaseSummary.elder.price = purchaseSummary.elder.qte * state.plans[0].elder.price;
        insured.elder = true;
      }
      // adult
      else if (age >= state.plans[0].adult.min_age && age <= state.plans[0].adult.max_age) {
        purchaseSummary.adult.qte += 1;
        purchaseSummary.adult.price = purchaseSummary.adult.qte * state.plans[0].adult.price;
      }
    } else {
      purchaseSummary.adult.qte += 1;
      purchaseSummary.adult.price = purchaseSummary.adult.qte * state.plans[0].adult.price;
    }
  });

  if (state.insuredForms.length > 1) state.isInsuredFormDeletable = true;

  purchaseSummary.subtotal = purchaseSummary.child.price + purchaseSummary.adult.price + purchaseSummary.elder.price;

  purchaseSummary.paymentMethodDiscountValue = 0.0;

  if (state.paymentMethods.filter((method) => method.selected).length > 0) {
    purchaseSummary.paymentMethodDiscountValue =
      state.paymentMethods.filter((method) => method.selected)[0] &&
      state.paymentMethods.filter((method) => method.selected)[0].discount > 0
        ? (
            (state.paymentMethods.filter((method) => method.selected)[0].discount / 100) *
            purchaseSummary.subtotal
          ).toFixed(2)
        : 0;
    purchaseSummary.paymentMethodSelected = state.paymentMethods.filter((method) => method.selected)[0]
      ? state.paymentMethods.filter((method) => method.selected)[0].name
      : 0;
    purchaseSummary.paymentMethodDiscountPercent = state.paymentMethods.filter((method) => method.selected)[0].discount;
  }

  purchaseSummary.total = (purchaseSummary.subtotal - purchaseSummary.paymentMethodDiscountValue).toFixed(2);

  purchaseSummary.coupon_discount = 0;

  if (state.coupon.payment_method === null || selectedPaymentMethod(paymentMethods) === state.coupon.payment_method) {
    if (state.coupon.discount_type === 0) purchaseSummary.coupon_discount = parseFloat(state.coupon.discount);
    else if (state.coupon.discount_type === 1)
      purchaseSummary.coupon_discount = (state.coupon.discount / 100) * purchaseSummary.total;
  }

  purchaseSummary.creditCouponCreditAmount = 0.0;
  if (state.creditCoupon && state.creditCoupon.creditAmount > 0 && state.creditCoupon.applied) {
    purchaseSummary.creditCouponCreditAmount = state.creditCoupon.creditAmount;
  }

  purchaseSummary.creditCouponAmountUsed = purchaseSummary.creditCouponCreditAmount;

  purchaseSummary.total -= purchaseSummary.coupon_discount;
  if (purchaseSummary.total < 0) {
    purchaseSummary.total = 0.0;
    purchaseSummary.creditCouponAmountUsed = 0;
  }

  if (purchaseSummary.total > 0) {
    purchaseSummary.total -= purchaseSummary.creditCouponCreditAmount;
  }

  if (purchaseSummary.total < 0) {
    purchaseSummary.creditCouponRemainingBalance = Math.abs(purchaseSummary.total);

    purchaseSummary.creditCouponAmountUsed =
      purchaseSummary.creditCouponCreditAmount - purchaseSummary.creditCouponRemainingBalance;

    purchaseSummary.total = 0.0;
  }

  if (purchaseSummary.total === 0) {
    paymentMethods.forEach((paymentMethod) => {
      paymentMethod.selected = false;
      if (paymentMethod.slug === 'pix') {
        paymentMethod.selected = true;
      }
    });
  }

  purchaseSummary.coupon_discount = purchaseSummary.coupon_discount.toFixed(2);

  // Investimento por dia
  const begin = new Date(state.quotationParams.departure_date);
  const end = new Date(state.quotationParams.return_date);

  const diffDays = getDaysDiff(begin, end);

  purchaseSummary.investmentPerDay = purchaseSummary.total / diffDays;

  return checkAvailablePaymentMethods({
    ...state,
    purchaseSummary,
    paymentMethods,
    alert,
  });
};

export const validatePurchase = (state) => {
  const EMPTY_FIELD = 'Este campo é obrigatório';
  const INVALID_VALUE = 'Preencha o campo corretamente';

  const { destination } = state.quotationParams;

  const errors = {
    insuredForms: state.insuredForms.map(() => [
      {
        cpf: false,
        rg: false,
        name: false,
        birth_date: false,
        incoming: false,
      },
    ]),
    paymentMethods: false,
    creditCard: {
      cvv: false,
      cpf: false,
      number: false,
      parcels: false,
      card_brand: false,
      expiry_year: false,
      holder_name: false,
      expiry_month: false,
    },
    boleto: {
      cpf: false,
      name: false,
    },
    safetypay: {
      cpf: false,
      name: false,
      banks: false,
      agency: false,
      account: false,
    },
    cash: {
      holderName: false,
      holderCpf: false,
    },
    pix: {
      name: false,
      cpf: false,
    },
    coupon: false,
    contact: {
      contact_name: false,
      email: false,
      phone_number: false,
      cep: false,
      city: false,
      state: false,
      number: false,
      address: false,
      district: false,
      complement: false,
    },
    purchase_is_valid: false,
    errorsModalFranchise: false,
  };

  const { plans, insuredForms, quotationParams } = state;

  const validDuplicateCPF = (birth_date) => {
    const birthDate = new Date(birth_date.split('/').reverse().join('/'));
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    if (age <= 5) return false;
    return true;
  };

  // Validar Formulários de Segurados
  insuredForms.forEach((insured, i) => {
    const { rg, cpf, passport, name, birth_date, document_type, incoming } = insured;
    // valida nome
    if (name === '') errors.insuredForms[i].name = 'Este campo é obrigatório';
    if (name.match(/^\s/)) {
      errors.insuredForms[i].name = 'Este campo não pode começar com espaço';
    }
    if (name.split(' ').length < 2) errors.insuredForms[i].name = 'Digite o nome Completo';
    if (!isValidName(name)) {
      errors.insuredForms[i].name = 'O nome não pode conter caracteres especiais.';
    }
    if (document_type === 'cpf') {
      // valida cpf
      if (!isValidCPF(cpf)) errors.insuredForms[i].cpf = INVALID_VALUE;
      if (cpf === '') errors.insuredForms[i].cpf = EMPTY_FIELD;
      for (let j = 0; j < insuredForms.length; j++) {
        if (
          j !== i &&
          insuredForms[j].cpf === cpf &&
          validDuplicateCPF(insuredForms[j].birth_date) &&
          validDuplicateCPF(insuredForms[i].birth_date)
        ) {
          errors.insuredForms[i].cpf = 'Esse CPF já está em uso.';
        }
      }
    } else if (document_type === 'rg') {
      // valida rg
      if (rg === '') errors.insuredForms[i].rg = EMPTY_FIELD;
    } else if (document_type === 'passport') {
      // valida rg
      if (passport.replace(/_/g, '').length < 6 || passport.replace(/_/g, '').length > 20)
        errors.insuredForms[i].passport = 'Passaporte inválido';
      if (passport === '') errors.insuredForms[i].passport = EMPTY_FIELD;
    }

    if (destination === 'receptivo') {
      if (incoming === '') errors.insuredForms[i].incoming = EMPTY_FIELD;
    }

    const minAge = plans[0].child.min_age;
    const maxAge = plans[0].elder.max_age;

    // valida data_nascimento
    if (!birth_date === '') errors.insuredForms[i].birth_date = EMPTY_FIELD;
    else if (isValidDate(birth_date, quotationParams.departure_date)) {
      const ageStatus = getAgeStatus(birth_date, quotationParams.departure_date, minAge, maxAge);
      if (ageStatus.aboveMaxAge)
        errors.insuredForms[i].birth_date =
          `O plano possui faixa etária limite de até ${maxAge} anos. Escolha um novo seguro.`;
      else if (ageStatus.belowMinAge) errors.insuredForms[i].birth_date = 'Verifique idade mínima do plano escolhido.';
    } else {
      errors.insuredForms[i].birth_date = INVALID_VALUE;
    }
  });
  // Validar Método de Pagamento
  let selectedPM = state.paymentMethods.filter((method) => method.selected);
  selectedPM = selectedPM.length ? selectedPM[0] : null;

  let selectCard = state.creditCard.brands.filter((brand) => brand.selected);
  selectCard = selectCard.length ? selectCard[0] : null;

  if (selectedPM) {
    if (!selectedPM.available) {
      if (selectedPM.slug === 'boleto') errors.paymentMethods = 'O Boleto não está disponível para a data selecionada';
      if (selectedPM.slug === 'safetypay')
        errors.paymentMethods = 'A transferência bancária não está disponível para a data selecionada';
    }

    if (selectedPM.slug === 'credit-card') {
      // Validar Cartão de Crédito
      // number
      if (selectCard) {
        if (!validateCreditCard(selectCard.brand_name, state.creditCard.number, 'number'))
          errors.creditCard.number = INVALID_VALUE;
      }
      // holder_name
      if (state.creditCard.holder_name === '') errors.creditCard.holder_name = EMPTY_FIELD;
      else if (state.creditCard.holder_name.split(' ').length < 2) errors.creditCard.holder_name = INVALID_VALUE;

      if (state.creditCard.holder_cpf === '') errors.creditCard.holder_cpf = EMPTY_FIELD;
      else if (!isValidCPF(state.creditCard.holder_cpf)) errors.creditCard.holder_cpf = INVALID_VALUE;

      if (state.creditCard.expiry_month === '') errors.creditCard.expiry_month = EMPTY_FIELD;
      else if (state.creditCard.expiry_month.length !== 2) errors.creditCard.expiry_month = INVALID_VALUE;

      if (state.creditCard.expiry_year === '') errors.creditCard.expiry_year = EMPTY_FIELD;
      else if (state.creditCard.expiry_year.length !== 4) errors.creditCard.expiry_year = INVALID_VALUE;

      if (state.creditCard.parcels.filter((p) => p.selected).length <= 0)
        errors.creditCard.parcels = 'Por favor, selecione a forma de parcelamento';

      // cvv
      if (!validateCreditCard(selectCard.brand_name, state.creditCard.cvv, 'cvv'))
        errors.creditCard.cvv = INVALID_VALUE;
    }

    if (selectedPM.slug === 'boleto') {
      // Validar Boleto
      // nome
      if (state.boleto.name === '') errors.boleto.name = EMPTY_FIELD;
      else if (state.boleto.name.split(' ').length < 2) errors.boleto.name = 'Digite o nome completo';
      // cpf
      if (state.boleto.cpf === '') errors.boleto.cpf = EMPTY_FIELD;
      else if (!isValidCPF(state.boleto.cpf)) errors.boleto.cpf = INVALID_VALUE;
    }
    if (selectedPM.slug === 'safetypay') {
      // Validar Transferência
      const selectedBank = state.safetypay.banks.filter((bank) => bank.selected)[0];
      if (!selectedBank) errors.safetypay.banks = 'Selecione um banco';

      // nome
      if (state.safetypay.name === '') errors.safetypay.name = EMPTY_FIELD;
      else if (state.safetypay.name.split(' ').length < 2) errors.safetypay.name = 'Digite o nome completo';
      // cpf
      if (state.safetypay.cpf === '') errors.safetypay.cpf = EMPTY_FIELD;
      else if (!isValidCPF(state.safetypay.cpf)) errors.safetypay.cpf = INVALID_VALUE;
    }

    if (selectedPM.slug === 'cash') {
      // Validar Dinheiro
      // responsável pelo pagamento
      if (state.cash.holderName === '') errors.cash.holderName = EMPTY_FIELD;
      // cpf do responsável
      if (!isValidCPF(state.cash.holderCpf)) errors.cash.holderCpf = INVALID_VALUE;
    }

    if (selectedPM.slug === 'pix') {
      if (state.pix.name === '') errors.pix.name = EMPTY_FIELD;
      if (!isValidCPF(state.pix.cpf)) errors.pix.cpf = INVALID_VALUE;
    }
  } else errors.paymentMethods = 'Selecione um método de pagamento';

  // contato
  // nome
  if (state.contact.contact_name === '') errors.contact.contact_name = EMPTY_FIELD;
  // email
  else if (state.contact.email === '') errors.contact.email = EMPTY_FIELD;
  if (!isValidEmail(state.contact.email)) errors.contact.email = INVALID_VALUE;
  // telefone
  if (state.contact.phone_number === '') errors.contact.phone_number = EMPTY_FIELD;
  else if (!isValidPhone(state.contact.phone_number)) errors.contact.phone_number = INVALID_VALUE;

  // endereço
  if (state.contact.cep === '') errors.contact.cep = EMPTY_FIELD;
  else if (!state.contact.cep.match(/^\d\d\.?\d\d\d-?\d\d\d$/)) errors.contact.cep = INVALID_VALUE;
  if (state.contact.city === '') errors.contact.city = EMPTY_FIELD;
  else if (state.contact.city.length < 3) errors.contact.city = EMPTY_FIELD;
  else if (state.contact.city.length > 100) errors.contact.city = 'A cidade deve ter no máximo 100 caracteres';
  if (state.contact.state === '') errors.contact.state = EMPTY_FIELD;
  if (state.contact.number === '') {
    if (!state.contact.complement || state.contact.complement.trim() === '') {
      errors.contact.number = EMPTY_FIELD;
    }
  } else {
    if (/[^0-9]/.test(state.contact.number)) {
      errors.contact.number = 'Digite apenas números';
    }
    if (state.contact.number.length > 10) {
      errors.contact.number = 'O número deve ter no máximo 10 caracteres';
    }
    if (state.contact.number === '0') {
      errors.contact.number = 'O número não pode ser 0';
    }
  }
  if (state.contact.address.length < 3) errors.contact.address = EMPTY_FIELD;
  if (state.contact.district === '') errors.contact.district = EMPTY_FIELD;
  if (state.contact.district.length < 3) errors.contact.district = EMPTY_FIELD;
  if (state.contact.district.length > 50) errors.contact.district = 'O bairro deve ter no máximo 50 caracteres';

  errors.errorsModalFranchise = true;
  let isOk = true;
  let anchor = '';

  // Vereifica se há error após a validação para que o formulário seja enviado
  for (const field1 in errors) {
    if (errors[field1] && typeof errors[field1] !== 'string') {
      for (const field2 in errors[field1]) {
        if (errors[field1][field2] && typeof errors[field1][field2] !== 'string') {
          for (const field3 in errors[field1][field2]) {
            if (errors[field1][field2][field3] && typeof errors[field1][field2][field3] !== 'string') {
              for (const field4 in errors[field1][field2][field3]) {
                if (typeof errors[field1][field2][field3][field4] === 'string') {
                  anchor = `${field1}_${field2}_${field3}_${field4}`;
                  isOk = false;
                  return {
                    ...state,
                    anchor,
                    errors,
                    purchase_is_valid: isOk,
                  };
                }
              }
            } else if (typeof errors[field1][field2][field3] === 'string') {
              anchor = `${field1}_${field2}_${field3}`;
              isOk = false;
              return {
                ...state,
                anchor,
                errors,
                purchase_is_valid: isOk,
              };
            }
          }
        } else if (typeof errors[field1][field2] === 'string') {
          anchor = `${field1}_${field2}`;
          isOk = false;
          return {
            ...state,
            anchor,
            errors,
            purchase_is_valid: isOk,
          };
        }
      }
    } else if (typeof errors[field1] === 'string') {
      anchor = `${field1}`;
      isOk = false;
      return {
        ...state,
        anchor,
        errors,
        purchase_is_valid: isOk,
      };
    }
  }

  return {
    ...state,
    anchor,
    errors,
    purchase_is_valid: true,
  };
};

export const validatePurchaseMobile = (state, stage) => {
  const EMPTY_FIELD = 'Este campo é obrigatório';
  const INVALID_VALUE = 'Preencha o campo corretamente';

  const errors = {
    insuredForms: state.insuredForms.map(() => [
      {
        cpf: false,
        rg: false,
        name: false,
        birth_date: false,
      },
    ]),
    paymentMethods: false,
    creditCard: {
      cvv: false,
      cpf: false,
      number: false,
      parcels: false,
      card_brand: false,
      expiry_year: false,
      holder_name: false,
      expiry_month: false,
    },
    boleto: {
      cpf: false,
      name: false,
    },
    safetypay: {
      cpf: false,
      name: false,
      banks: false,
      agency: false,
      account: false,
    },
    cash: {
      username: false,
      password: false,
    },
    pix: {
      name: false,
      cpf: false,
    },
    coupon: false,
    contact: {
      contact_name: false,
      email: false,
      phone_number: false,
      cep: false,
      city: false,
      state: false,
      number: false,
      address: false,
      district: false,
      complement: false,
    },
    purchase_is_valid: false,
    errorsModalFranchise: false,
  };

  const { plans, insuredForms, quotationParams } = state;

  const validDuplicateCPF = (birth_date) => {
    const birthDate = new Date(birth_date.split('/').reverse().join('/'));
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    if (age <= 5) return false;
    return true;
  };

  // Validar Formulários de Segurados
  switch (stage) {
    case 'INSURED_CONTACT':
      insuredForms.forEach((insured, i) => {
        const { rg, cpf, name, birth_date, document_type } = insured;

        // valida nome
        if (name === '') errors.insuredForms[i].name = 'Este campo é obrigatório';
        if (name.split(' ').length < 2) {
          errors.insuredForms[i].name = 'Digite o nome Completo';
        }

        if (document_type === 'cpf') {
          // valida cpf
          if (!isValidCPF(cpf)) errors.insuredForms[i].cpf = INVALID_VALUE;
          if (cpf === '') errors.insuredForms[i].cpf = EMPTY_FIELD;
          for (let j = 0; j < insuredForms.length; j++) {
            if (
              i !== j &&
              insuredForms[j].cpf === cpf &&
              validDuplicateCPF(insuredForms[j].birth_date) &&
              validDuplicateCPF(insuredForms[i].birth_date)
            ) {
              errors.insuredForms[i].cpf =
                'Esse CPF já está em uso. Crianças de 0 a 5 anos solicitamos que seja preenchido com o CPF do titular.';
            }
          }
        } else if (document_type === 'rg') {
          // valida rg
          if (rg === '') errors.insuredForms[i].rg = EMPTY_FIELD;
        }
        const minAge = plans[0].child.min_age;
        const maxAge = plans[0].elder.max_age;

        // valida data_nascimento
        if (birth_date === '') {
          errors.insuredForms[i].birth_date = EMPTY_FIELD;
        } else if (isValidDate(birth_date, quotationParams.departure_date)) {
          const ageStatus = getAgeStatus(birth_date, quotationParams.departure_date, minAge, maxAge);

          if (ageStatus.aboveMaxAge)
            errors.insuredForms[i].birth_date =
              `O plano possui faixa etária limite de até ${maxAge} anos. Escolha um novo seguro.`;
          else if (ageStatus.belowMinAge)
            errors.insuredForms[i].birth_date = 'Verifique idade mínima do plano escolhido.';
        } else errors.insuredForms[i].birth_date = INVALID_VALUE;
      });
      break;
    case 'INSURED_PAYMENT_PURCHASE':
      insuredForms.forEach((insured, i) => {
        const { rg, cpf, name, birth_date, document_type } = insured;

        // valida nome
        if (name === '') errors.insuredForms[i].name = 'Este campo é obrigatório';
        if (name.split(' ').length < 2) errors.insuredForms[i].name = 'Digite o nome Completo';

        if (document_type === 'cpf') {
          // valida cpf
          if (!isValidCPF(cpf)) errors.insuredForms[i].cpf = INVALID_VALUE;
          if (cpf === '') errors.insuredForms[i].cpf = EMPTY_FIELD;
        } else if (document_type === 'rg') {
          // valida rg
          if (rg === '') errors.insuredForms[i].rg = EMPTY_FIELD;
        }

        const minAge = plans[0].child.min_age;
        const maxAge = plans[0].elder.max_age;

        // valida data_nascimento
        if (!birth_date === '') errors.insuredForms[i].birth_date = EMPTY_FIELD;
        else if (isValidDate(birth_date, quotationParams.departure_date)) {
          const ageStatus = getAgeStatus(birth_date, quotationParams.departure_date, minAge, maxAge);

          if (ageStatus.aboveMaxAge)
            errors.insuredForms[i].birth_date =
              `O plano possui faixa etária limite de até ${maxAge} anos. Escolha um novo seguro.`;
          else if (ageStatus.belowMinAge)
            errors.insuredForms[i].birth_date = 'Verifique idade mínima do plano escolhido.';
        } else errors.insuredForms[i].birth_date = INVALID_VALUE;
      });
      // Validar Método de Pagamento
      let selectedPM = state.paymentMethods.filter((method) => method.selected);
      selectedPM = selectedPM.length ? selectedPM[0] : null;

      let selectCard = state.creditCard.brands.filter((brand) => brand.selected);
      selectCard = selectCard.length ? selectCard[0] : null;

      if (selectedPM) {
        if (!selectedPM.available) {
          if (selectedPM.slug === 'boleto')
            errors.paymentMethods = 'O Boleto não está disponível para a data selecionada';
          if (selectedPM.slug === 'safetypay')
            errors.paymentMethods = 'A transferência bancária não está disponível para a data selecionada';
        }

        if (selectedPM.slug === 'credit-card') {
          // Validar Cartão de Crédito
          // number
          if (selectCard) {
            // validação de número de digitos por bandeira
            if (!validateCreditCard(selectCard.brand_name, state.creditCard.number, 'number'))
              errors.creditCard.number = INVALID_VALUE;
          }
          // holder_name
          if (state.creditCard.holder_name === '') errors.creditCard.holder_name = EMPTY_FIELD;
          else if (state.creditCard.holder_name.split(' ').length < 2) errors.creditCard.holder_name = INVALID_VALUE;

          if (state.creditCard.holder_cpf === '') errors.creditCard.holder_cpf = EMPTY_FIELD;
          else if (!isValidCPF(state.creditCard.holder_cpf)) errors.creditCard.holder_cpf = INVALID_VALUE;

          if (state.creditCard.expiry_month === '') errors.creditCard.expiry_month = EMPTY_FIELD;
          else if (state.creditCard.expiry_month.length !== 2) errors.creditCard.expiry_month = INVALID_VALUE;

          if (state.creditCard.expiry_year === '') errors.creditCard.expiry_year = EMPTY_FIELD;
          else if (state.creditCard.expiry_year.length !== 4) errors.creditCard.expiry_year = INVALID_VALUE;

          if (state.creditCard.parcels.filter((p) => p.selected).length <= 0)
            errors.creditCard.parcels = 'Por favor, selecione a forma de parcelamento';

          // cvv
          if (!validateCreditCard(selectCard.brand_name, state.creditCard.cvv, 'cvv'))
            errors.creditCard.cvv = INVALID_VALUE;
        }
        if (selectedPM.slug === 'pix') {
          if (state.pix.cpf === '') errors.pix.cpf = EMPTY_FIELD;
          else if (!isValidCPF(state.pix.cpf)) errors.pix.cpf = INVALID_VALUE;
        }
        if (selectedPM.slug === 'boleto') {
          // Validar Boleto
          // nome
          if (state.boleto.name === '') errors.boleto.name = EMPTY_FIELD;
          else if (state.boleto.name.split(' ').length < 2) errors.boleto.name = 'Digite o nome completo';
          // cpf
          if (state.boleto.cpf === '') errors.boleto.cpf = EMPTY_FIELD;
          else if (!isValidCPF(state.boleto.cpf)) errors.boleto.cpf = INVALID_VALUE;
        }
        if (selectedPM.slug === 'safetypay') {
          // Validar Transferência
          const selectedBank = state.safetypay.banks.filter((bank) => bank.selected)[0];
          if (!selectedBank) errors.safetypay.banks = 'Selecione um banco';

          // nome
          if (state.safetypay.name === '') errors.safetypay.name = EMPTY_FIELD;
          else if (state.safetypay.name.split(' ').length < 2) errors.safetypay.name = 'Digite o nome completo';
          // cpf
          if (state.safetypay.cpf === '') errors.safetypay.cpf = EMPTY_FIELD;
          else if (!isValidCPF(state.safetypay.cpf)) errors.safetypay.cpf = INVALID_VALUE;
        }

        if (selectedPM.slug === 'cash') {
          // Validar Dinheiro
          // Responsável pelo pagamento
          if (state.cash.holderName === '') errors.cash.holderName = EMPTY_FIELD;
          // Cpf do responsável pelo pagamento
          if (state.cash.holderCpf === '') errors.cash.holderCpf = EMPTY_FIELD;
        }
      } else errors.paymentMethods = 'Selecione um método de pagamento';
      break;
    case 'INSURED_RESP_CONTACT':
      // contato
      // nome
      if (state.contact.contact_name === '') errors.contact.contact_name = EMPTY_FIELD;
      // email
      else if (state.contact.email === '') errors.contact.email = EMPTY_FIELD;
      if (!isValidEmail(state.contact.email)) errors.contact.email = INVALID_VALUE;
      // telefone
      if (state.contact.phone_number === '') errors.contact.phone_number = EMPTY_FIELD;
      else if (!isValidPhone(state.contact.phone_number)) errors.contact.phone_number = INVALID_VALUE;

      // endereço
      if (state.contact.cep === '') errors.contact.cep = EMPTY_FIELD;
      else if (!state.contact.cep.match(/^\d\d\.?\d\d\d-?\d\d\d$/)) errors.contact.cep = INVALID_VALUE;
      if (state.contact.city === '') errors.contact.city = EMPTY_FIELD;
      else if (state.contact.city === ' ') errors.contact.city = EMPTY_FIELD;
      else if (state.contact.city.length > 100) errors.contact.city = 'A cidade deve ter no máximo 100 caracteres';
      if (state.contact.state === '') errors.contact.state = EMPTY_FIELD;
      if (state.contact.number === '') {
        if (!state.contact.complement || state.contact.complement.trim() === '') {
          errors.contact.number = EMPTY_FIELD;
        }
      } else {
        if (/[^0-9]/.test(state.contact.number)) {
          errors.contact.number = 'Digite apenas números';
        }
        if (state.contact.number.length > 10) {
          errors.contact.number = 'O número deve ter no máximo 10 caracteres';
        }
        if (state.contact.number === '0') {
          errors.contact.number = 'O número não pode ser 0';
        }
      }
      if (state.contact.address === '') errors.contact.address = EMPTY_FIELD;
      else if (state.contact.address === ' ') errors.contact.address = EMPTY_FIELD;
      if (state.contact.district === '') errors.contact.district = EMPTY_FIELD;
      else if (state.contact.district.length < 3) errors.contact.district = EMPTY_FIELD;
      else if (state.contact.district.length > 50)
        errors.contact.district = 'O bairro deve ter no máximo 50 caracteres';
      break;
    default:
      break;
  }

  errors.errorsModalFranchise = true;
  let isOk = true;
  let anchor = '';

  // Vereifica se há error após a validação para que o formulário seja enviado
  for (const field1 in errors) {
    if (errors[field1] && typeof errors[field1] !== 'string') {
      for (const field2 in errors[field1]) {
        if (errors[field1][field2] && typeof errors[field1][field2] !== 'string') {
          for (const field3 in errors[field1][field2]) {
            if (errors[field1][field2][field3] && typeof errors[field1][field2][field3] !== 'string') {
              for (const field4 in errors[field1][field2][field3]) {
                if (typeof errors[field1][field2][field3][field4] === 'string') {
                  anchor = `${field1}_${field2}_${field3}_${field4}`;
                  isOk = false;
                  return {
                    ...state,
                    anchor,
                    errors,
                    purchase_is_valid: isOk,
                  };
                }
              }
            } else if (typeof errors[field1][field2][field3] === 'string') {
              anchor = `${field1}_${field2}_${field3}`;
              isOk = false;
              return {
                ...state,
                anchor,
                errors,
                purchase_is_valid: isOk,
              };
            }
          }
        } else if (typeof errors[field1][field2] === 'string') {
          anchor = `${field1}_${field2}`;
          isOk = false;
          return {
            ...state,
            anchor,
            errors,
            purchase_is_valid: isOk,
          };
        }
      }
    } else if (typeof errors[field1] === 'string') {
      anchor = `${field1}`;
      isOk = false;
      return {
        ...state,
        anchor,
        errors,
        purchase_is_valid: isOk,
      };
    }
  }

  return {
    ...state,
    anchor,
    errors,
    purchase_is_valid: true,
  };
};

export function isValidName(name) {
  return /^[A-Za-zÀ-ÖØ-öø-ÿ\s]+$/.test(name.trim());
}

export const validatePurchaseOnBlur = (value, name, index, state) => {
  const errors = {
    insuredForms: [],
    paymentMethods: false,
    creditCard: {},
    boleto: {},
    safetypay: {},
    cash: {
      username: false,
      password: false,
    },
    pix: {},
    coupon: false,
    contact: {},
    purchase_is_valid: false,
    errorsModalFranchise: false,
    just_loaded: true,
  };

  const EMPTY_FIELD = 'Este campo é obrigatório';
  const INVALID_VALUE = 'Preencha o campo corretamente';

  const { plans } = state;

  let selectCard = state.creditCard.brands.filter((brand) => brand.selected);
  selectCard = selectCard.length ? selectCard[0] : null;

  errors.insuredForms = state.errors.insuredForms;
  errors.boleto = state.errors.boleto;
  errors.safetypay = state.errors.safetypay;
  errors.creditCard = state.errors.creditCard;
  errors.pix = state.errors.pix;
  errors.contact = state.errors.contact;

  // VALIDAÇÃO SEGURADOS
  if (name === 'name') {
    if (errors.insuredForms[index]) {
      errors.insuredForms[index].name = false;
      if (value === '') {
        errors.insuredForms[index].name = 'Este campo é obrigatório';
      }
      if (value.match(/^\s/)) {
        errors.insuredForms[index].name = 'Este campo não pode começar com espaço';
      }
      if (value.split(' ').length < 2) {
        errors.insuredForms[index].name = 'Digite o nome Completo';
      }
      if (!isValidName(value)) {
        errors.insuredForms[index].name = 'O nome não pode conter caracteres especiais.';
      }
    }
  }
  if (name === 'cpf') {
    if (index <= errors.insuredForms.length - 1) {
      errors.insuredForms[index].cpf = false;
      if (!isValidCPF(value) && errors.insuredForms[index].cpf) errors.insuredForms[index].cpf = INVALID_VALUE;
      if (value === '') errors.insuredForms[index].cpf = EMPTY_FIELD;
    }
    if (errors.insuredForms[index]) {
      errors.insuredForms[index].just_loaded = false;
    }
  }
  if (name === 'passport') {
    if (index <= errors.insuredForms.length - 1) {
      errors.insuredForms[index].passport = false;
      if (value.replace(/_/g, '').length < 6) {
        errors.insuredForms[index].passport = INVALID_VALUE;
      }
      if (value === '') errors.insuredForms[index].passport = EMPTY_FIELD;
    }
    errors.insuredForms[index].just_loaded = false;
  }

  // optional incoming
  if (name === 'incoming') {
    errors.insuredForms[index].incoming = false;
    if (value === '') errors.insuredForms[index].incoming = EMPTY_FIELD;
    else {
      errors.just_loaded = false;
    }
  }

  const minAge = plans[0].child.min_age;
  const maxAge = plans[0].elder.max_age;

  if (name === 'birth_date') {
    if (value === '') {
      errors.insuredForms[index].birth_date = EMPTY_FIELD;
    } else if (isValidDate(value, state.quotationParams.departure_date)) {
      const ageStatus = getAgeStatus(value, state.quotationParams.departure_date, minAge, maxAge);
      if (ageStatus.aboveMaxAge) {
        errors.insuredForms[index].birth_date =
          `O plano possui faixa etária limite de até ${maxAge} anos. Escolha um novo seguro.`;
      } else if (ageStatus.belowMinAge) {
        errors.insuredForms[index].birth_date = 'Verifique idade mínima do plano escolhido.';
      } else {
        if (errors.insuredForms && errors.insuredForms[index]) {
          errors.insuredForms[index].birth_date = false;
        }
      }
    } else {
      errors.insuredForms[index].birth_date = INVALID_VALUE;
    }
  }

  // datalayer when all 3 inputs are correct
  if (name === 'name' || name === 'birth_data' || name === 'cpf') {
    if (
      errors.insuredForms &&
      errors.insuredForms[index] &&
      errors.insuredForms[index].birth_date === false &&
      errors.insuredForms[index].cpf === false &&
      errors.insuredForms[index].name === false &&
      errors.insuredForms[index].just_loaded === false
    ) {
      dataLayer.raw({ event: 'inclusao_dados_identificacao' });
    }
  }

  // VALIDAÇÃO BOLETO
  if (name === 'boleto_name') {
    errors.boleto.name = false;
    if (state.boleto.name === '') errors.boleto.name = EMPTY_FIELD;
    else if (state.boleto.name.split(' ').length < 2) errors.boleto.name = 'Digite o nome completo';
  }

  if (name === 'boleto_cpf') {
    errors.boleto.cpf = false;
    if (state.boleto.cpf === '') errors.boleto.cpf = EMPTY_FIELD;
    else if (!isValidCPF(state.boleto.cpf)) errors.boleto.cpf = INVALID_VALUE;
    else {
      errors.just_loaded = false;
    }
  }

  if (errors.boleto.cpf === false && errors.boleto.name === false && errors.just_loaded === false) {
    dataLayer.raw({ event: 'inclusao_dados_pagamento' });
  }

  // VALIDAÇÃO PIX
  if (name === 'pix_name') {
    errors.pix.name = false;
    if (state.pix.name === '') errors.pix.name = EMPTY_FIELD;
    else if (state.pix.name.split(' ').length < 2) errors.pix.name = 'Digite o nome completo';
  }

  if (name === 'pix_cpf') {
    errors.pix.cpf = false;
    if (state.pix.cpf === '') errors.pix.cpf = EMPTY_FIELD;
    else if (!isValidCPF(state.pix.cpf)) errors.pix.cpf = INVALID_VALUE;
    else {
      errors.just_loaded = false;
    }
  }

  if (errors.pix.cpf === false && errors.pix.name === false && errors.just_loaded === false) {
    dataLayer.raw({ event: 'inclusao_dados_pagamento' });
  }

  // VALIDAÇÃO TRANSFERENCIA
  if (name === 'transf_name') {
    errors.safetypay.name = false;
    if (state.safetypay.name === '') errors.safetypay.name = EMPTY_FIELD;
    else if (state.safetypay.name.split(' ').length < 2) errors.safetypay.name = 'Digite o nome completo';
  }

  if (name === 'transf_cpf') {
    errors.safetypay.cpf = false;
    if (state.safetypay.cpf === '') errors.safetypay.cpf = EMPTY_FIELD;
    else if (!isValidCPF(state.safetypay.cpf)) errors.safetypay.cpf = INVALID_VALUE;
  }

  if (name === 'transf_agency') {
    if (typeof errors.safetypay.agency === 'string') {
      errors.safetypay.agency = false;
      if (state.safetypay.agency === '') errors.safetypay.agency = EMPTY_FIELD;
      else if (!state.safetypay.agency.match(/\d{4}-?\d?/)) errors.safetypay.agency = INVALID_VALUE;
    }
  }

  if (name === 'transf_account') {
    errors.safetypay.account = false;
    if (state.safetypay.account === '') errors.safetypay.account = EMPTY_FIELD;
    else if (!state.safetypay.account.match(/\d{4}-?\d?/)) errors.safetypay.account = INVALID_VALUE;
  }

  // VALIDAÇÃO CARTÃO DE CRÉDITO
  if (name === 'creditcard_number') {
    errors.creditCard.number = false;
    if (!validateCreditCard(selectCard.brand_name, state.creditCard.number, 'number'))
      errors.creditCard.number = INVALID_VALUE;
  }

  if (name === 'creditcard_month') {
    errors.creditCard.expiry_month = false;
    if (state.creditCard.expiry_month === '') errors.creditCard.expiry_month = EMPTY_FIELD;
    else if (state.creditCard.expiry_month.length !== 2) errors.creditCard.expiry_month = INVALID_VALUE;
  }

  if (name === 'creditcard_year') {
    errors.creditCard.expiry_year = false;
    if (state.creditCard.expiry_year === '') errors.creditCard.expiry_year = EMPTY_FIELD;
    else if (state.creditCard.expiry_year.length !== 4) errors.creditCard.expiry_year = INVALID_VALUE;
  }

  if (name === 'creditcard_cvv') {
    errors.creditCard.cvv = false;
    if (!validateCreditCard(selectCard.brand_name, state.creditCard.cvv, 'cvv')) errors.creditCard.cvv = INVALID_VALUE;
  }

  if (name === 'creditcard_holdername') {
    errors.creditCard.holder_name = false;
    if (state.creditCard.holder_name === '') errors.creditCard.holder_name = EMPTY_FIELD;
    else if (state.creditCard.holder_name.split(' ').length < 2) errors.creditCard.holder_name = INVALID_VALUE;
  }

  if (name === 'creditcard_holdercpf') {
    errors.creditCard.holder_cpf = false;
    if (state.creditCard.holder_cpf === '') errors.creditCard.holder_cpf = EMPTY_FIELD;
    else if (!isValidCPF(state.creditCard.holder_cpf)) errors.creditCard.holder_cpf = INVALID_VALUE;
  }

  // DADOS DO CONTATO
  if (name === 'contact_name') {
    errors.contact.contact_name = false;
    if (state.contact.contact_name === '') errors.contact.contact_name = EMPTY_FIELD;
  }

  if (name === 'contact_email') {
    errors.contact.email = false;
    if (state.contact.email === '') errors.contact.email = EMPTY_FIELD;
    if (!isValidEmail(state.contact.email)) errors.contact.email = INVALID_VALUE;
  }

  if (name === 'contact_phone') {
    errors.contact.phone_number = false;
    if (state.contact.phone_number === '') errors.contact.phone_number = EMPTY_FIELD;
    else if (!isValidPhone(state.contact.phone_number)) errors.contact.phone_number = INVALID_VALUE;
  }

  if (name === 'contact_cep') {
    errors.contact.cep = false;
    if (state.contact.cep === '') errors.contact.cep = EMPTY_FIELD;
    else if (!state.contact.cep.match(/^\d\d\.?\d\d\d-?\d\d\d$/)) errors.contact.cep = INVALID_VALUE;
  }

  if (name === 'contact_address') {
    errors.contact.address = false;
    if (state.contact.address === '') if (state.contact.address.length < 3) errors.contact.address = EMPTY_FIELD;
  }

  if (name === 'contact_number') {
    errors.contact.number = false;
    const numberVal = state.contact.number;
    const complementVal = state.contact.complement;

    if (numberVal === '') {
      if (!complementVal || complementVal.trim() === '') {
        errors.contact.number = EMPTY_FIELD;
      }
    } else {
      if (/[^0-9]/.test(numberVal)) {
        errors.contact.number = 'Digite apenas números';
      }
      if (numberVal.length > 10) {
        errors.contact.number = 'O número deve ter no máximo 10 caracteres';
      }
      if (numberVal === '0') {
        errors.contact.number = 'O número não pode ser 0';
      }
    }
  }

  if (name === 'contact_district') {
    errors.contact.district = false;
    if (state.contact.district === '') {
      errors.contact.district = EMPTY_FIELD;
    } else {
      if (state.contact.district.length < 3) errors.contact.district = EMPTY_FIELD;
      if (state.contact.district.length > 50) errors.contact.district = 'O bairro deve ter no máximo 50 caracteres';
    }
  }

  if (name === 'contact_city') {
    errors.contact.city = false;
    if (state.contact.city === '') {
      errors.contact.city = EMPTY_FIELD;
    } else {
      if (state.contact.city.length < 3) errors.contact.city = EMPTY_FIELD;
      if (state.contact.city.length > 100) errors.contact.city = 'A cidade deve ter no máximo 100 caracteres';
    }
  }

  if (name === 'contact_state') {
    errors.contact.state = false;
    if (state.contact.state === '') errors.contact.state = EMPTY_FIELD;
    else {
      errors.just_loaded = false;
    }
  }

  const { address, cep, city, contact_name, email, number, phone_number } = errors.contact;

  if (
    address === false &&
    cep === false &&
    city === false &&
    contact_name === false &&
    email === false &&
    number === false &&
    phone_number === false &&
    errors.contact.state === false &&
    errors.just_loaded === false
  ) {
    dataLayer.raw({ event: 'inclusao_dados_contato' });
  }

  errors.errorsModalFranchise = true;
  return errors;
};

export const getProductDiscount = (price, productId, coupon) => {
  if (!coupon) return 0;
  if (!coupon.products) return 0;
  if (!coupon.products.includes(productId.toString())) return 0;

  let newPrice = price;

  if (coupon.discount_type === 1) newPrice *= 1 - coupon.discount / 100;
  else if (coupon.discount_type === 0) newPrice -= coupon.discount;

  return newPrice;
};

export const getDaysDiff = (begin, end) =>
  Math.ceil(Math.abs(end.getTime() - begin.getTime()) / (1000 * 3600 * 24)) + 1;

export const changeTitle = (page, custom = '') => {
  let title = HOME_PAGE_TITLE;

  switch (page) {
    case 'search':
      title = `${SEARCH_PAGE_TITLE} ${getDestinationBySlug(custom)}`;
      break;
    case 'comparison':
      title = COMPARISON_PAGE_TITLE;
      break;
    case 'detail':
      title = DETAIL_PAGE_TITLE;
      break;
    case 'purchase':
      title = PURCHASE_PAGE_TITLE;
      break;
    default:
      title = HOME_PAGE_TITLE;
  }

  document.title = title;
};

// #region Checks
export const isB2b = () => window.location.pathname.includes('/b2b/');

export const cleanDate = (date) => date.match(/(\d{4}-\d{2}-\d{2})/)[1];

export const cleanSlugDestination = (slug) => {
  switch (slug) {
    case 'brasil':
      return 'Brasil';
    case 'america-do-sul':
      return 'América do Sul';
    case 'europa':
      return 'Europa';
    case 'america-do-norte':
      return 'América do Norte';
    case 'america-central':
      return 'América Central';
    case 'oceania':
      return 'Oceania';
    case 'oriente-medio':
      return 'Oriente Médio';
    case 'asia':
      return 'Ásia';
    case 'africa':
      return 'África';
    case 'maritimo':
      return 'Marítimo';
    case 'internacional':
      return 'Internacional';
    case 'receptivo':
      return 'Receptivo';
    default:
      return '';
  }
};

export const isMobile = () => window.innerWidth < 768;

export const getDateFormat = (dateString) => {
  if (typeof dateString !== 'string') return '';

  const brFormatRegex = new RegExp(
    '(' +
      '(((^[0-2][0-9]|3[0-1])/(0[13578]|10|12))|' + // dia/mes
      '((^[0-2][0-9]|30)/(0[469]|11))|' + // dia/mes
      '(^[0-2][0-9]/02))' + // dia/mes
      '/((18|19|20)[0-9]{2})$' + // ano
      ')',
    'i'
  );
  const utcFormatRegex = new RegExp(
    '(' +
      '(^(18|19|20)[0-9]{2})-' + // ano
      '(((0[13578]|10|12)-([0-2][0-9]|3[0-1]))|' + // dia-mes
      '((0[469]|11)-([0-2][0-9]|30))|' + // dia-mes
      '(02-[0-2][0-9]))' + // dia-mes
      ')',
    'i'
  );

  if (dateString.match(brFormatRegex)) return 'br';
  if (dateString.match(utcFormatRegex)) return 'utc';

  return '';
};

export const isValidDate = (dateString, refDate) => {
  const dateFormat = getDateFormat(dateString);

  if (dateFormat === '') return;

  let fmtDate = dateString;
  const splDateString = dateString.split('/');

  if (dateFormat === 'br') {
    fmtDate = `${splDateString[2]}-${splDateString[1]}-${splDateString[0]}`;
  }

  const date = new Date(fmtDate);
  const ref = new Date(refDate);

  if (date.getUTCFullYear() > ref.getFullYear()) return false;

  if (date.getUTCFullYear() === ref.getUTCFullYear()) {
    if (date.getUTCMonth() > ref.getUTCMonth()) return false;
    if (date.getUTCMonth() === ref.getUTCMonth()) if (date.getUTCDate() > ref.getUTCDate()) return false;
  }

  return true;
};

export const getAgeStatus = (birthDateString, refDateString, minAge, maxAge) => {
  let formattedBirthDateString = birthDateString.split('/');
  formattedBirthDateString = `${formattedBirthDateString[2]}-${formattedBirthDateString[1]}-${formattedBirthDateString[0]}`;

  const time = new Date();
  const birthDate = new Date(formattedBirthDateString);
  const refDate = new Date(refDateString);
  refDate.setDate(time.getDate() + 1);
  let aboveMaxAge = false;
  let belowMinAge = false;

  let age = 0;

  if (
    (birthDate.getUTCDate() < refDate.getUTCDate() && birthDate.getUTCMonth() === refDate.getUTCMonth()) ||
    birthDate.getUTCMonth() < refDate.getUTCMonth()
  ) {
    // Has already had a birthday
    age = refDate.getUTCFullYear() - birthDate.getUTCFullYear();
  } else {
    // Hasn't had a birthday yet
    age = refDate.getUTCFullYear() - birthDate.getUTCFullYear() - 1;
  }

  if (age > maxAge) {
    aboveMaxAge = true;
  }

  if (age < minAge) {
    belowMinAge = true;
  }

  return {
    aboveMaxAge,
    belowMinAge,
  };
};

export const isValidCPF = (cpf) => {
  const allEqual = (input) => input.split('').every((char) => char === input[0]);

  const cpfString = cpf.replace(/\./g, '').replace(/-/g, '');

  let Soma;
  let Resto;
  Soma = 0;

  if (allEqual(cpfString)) return false;
  if (cpfString === '01234567890') return false;

  for (let i = 1; i <= 9; i += 1) Soma += parseInt(cpfString.substring(i - 1, i), 10) * (11 - i);
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== parseInt(cpfString.substring(9, 10), 10)) return false;

  Soma = 0;
  for (let i = 1; i <= 10; i += 1) Soma += parseInt(cpfString.substring(i - 1, i), 10) * (12 - i);
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== parseInt(cpfString.substring(10, 11), 10)) return false;

  return true;
};

export const isValidEmail = (emailString) => {
  const regex = new RegExp(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  const match = emailString.match(regex);
  if (match) return true;
  return false;
};

export const isValidPhone = (phone) => {
  const regex = new RegExp(/^\(?[0-9]{2}\)? ?[0-9]{5} ?-?[0-9]{4}$/);
  const match = phone.replace('_', '').match(regex);
  if (match) return true;
  return false;
};
// #endregion

// #region CookieUtilities
export const setCookie = (cname, cvalue, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${cvalue};${expires};path=/`;
};

export const getCookie = (name) => {
  const cookie = document.cookie.split('; ').find((row) => row.startsWith(`${name}=`));

  if (!cookie) {
    return '';
  }

  let value = cookie.substring(name.length + 1);

  if (value.startsWith('"') && value.endsWith('"')) {
    value = value.slice(1, -1);
  }

  return value;
};

export const checkCookie = (cookieName) => {
  if (getCookie(cookieName) !== '' && getCookie(cookieName) != null) return true;
  return false;
};

export const removeCookie = (cookieName) => {
  if (cookieName.indexOf('pcrid') === -1 || cookieName.indexOf('pcrslug') === -1)
    document.cookie = `${cookieName}=;path=/;domain=.segurospromo.com.br`;
};

export const removeOperatorCookies = () => {
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookies = decodedCookie.split('; ');

  cookies.forEach((cookie) => {
    if (cookie.includes('operator_')) {
      const operator = cookie.trim().split('=')[0];

      document.cookie = `${operator}=; path=/; Max-Age=-1`;
    }
  });
};

export function getAllCookies() {
  const bareCookies = document.cookie.split(';');

  const dictCookies = {};

  for (let cookie of bareCookies) {
    const [key, value] = cookie.split('=');

    dictCookies[key] = value;
  }

  return dictCookies;
}

export function getPartnersCookie() {
  const partnersList = [];

  const cookies = getAllCookies();

  for (const [key, value] of Object.entries(cookies)) {
    if (key.includes('pcrid_')) {
      const [last_access, expiration, pcrtt] = value.split('|');

      const partnerData = {
        pcrid: key.split('_')[1],

        last_access: last_access,

        expiration: expiration,

        tags: pcrtt,
      };

      partnersList.push(partnerData);
    }

    if (key.includes('pcrslug_')) {
      const [last_access, expiration, pcrtt] = value.split('|');

      const partnerData = {
        pcrslug: key.split('_')[1],

        last_access: last_access,

        expiration: expiration,

        tags: pcrtt,
      };

      partnersList.push(partnerData);
    }
  }

  return partnersList;
}

export const getOperatorsCookie = () => {
  const operators = [];

  const decodedCookie = decodeURIComponent(document.cookie);
  const cookies = decodedCookie.split('; ');
  cookies.forEach((cookie) => {
    if (cookie.includes('operator_')) {
      const [operator, accessDate] = cookie.trim().split('=');
      const [, operatorId] = operator.split('_');

      operators.push({
        operator_id: `SV-${operatorId}`,
        access_date: accessDate ? parseInt(accessDate, 10) : 0,
      });
    }
  });

  return operators;
};

export const getAuthCookie = () => {
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookies = decodedCookie.split('; ');

  let validCookie = null;

  cookies.forEach((cookie) => {
    if (cookie.startsWith('a_u=')) {
      const value = cookie.trim().split('=')[1] || '';

      if (value && value.trim() !== '') {
        validCookie = value;
      }
    }
  });

  return validCookie;
};

// #endregion

// #region Formatters
export const formatPrice = (price) => {
  if (!price) return null;

  return parseFloat(price).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    currency: 'BRL',
  });
};

export const formatDate = (date, format) => {
  if (typeof date !== 'string') return date;

  const splitDate = date.split('-');
  const fmtDate = `${splitDate[0]}/${splitDate[1]}/${splitDate[2]}`;

  if (format === 'pt-br') {
    return `${splitDate[2]}/${splitDate[1]}/${splitDate[0]}`;
  }

  return fmtDate;
};

export const formatURL = (params, url, search, ignoreSearch) => {
  const fmtReq = (oldUrl) => {
    let fmtUrl = '';
    let isFirst = true;

    oldUrl.split('').forEach((character) => {
      if (character === '?' && isFirst) {
        isFirst = false;
        fmtUrl += character;
      } else if (character === '?') fmtUrl += '&';
      else fmtUrl += character;
    });
    return fmtUrl;
  };

  let basePath = '',
    fmtUrl = '',
    getParams = window.location.search;

  if (params.partner) {
    basePath = `/p/${params.partner}`;
  } else if (params.user) {
    basePath = `/b2b/belvitur/${params.user}`;
  } else {
    basePath = '/site';
  }

  if (!url.includes('comparacao')) getParams = getParams.replace(/products_ids=[0-9,+]+&?/, '');

  if (ignoreSearch) fmtUrl = basePath + url;
  else if (search) fmtUrl = basePath + url + search;
  else fmtUrl = basePath + url + getParams;

  return fmtReq(fmtUrl);
};
// #endregion

export const getPage = () => {
  if (window.location.pathname.includes('pedido/')) return 'pagamento';
  if (window.location.pathname.includes('pedido-finalizado/')) return 'pos-compra';
  if (window.location.pathname.includes('cobertura/')) return 'cobertura';
  if (window.location.pathname.includes('comparacao/')) return 'comparacao';

  return 'pesquisa';
};

export const isSameDaySearch = (departureDate) => {
  const fmtDepartureDate = new Date(
    departureDate.substr(0, 4),
    parseInt(departureDate.substr(5, 2), 0) - 1,
    departureDate.substr(8, 2),
    0,
    0,
    0,
    0
  );

  if (new Date().toLocaleDateString() === fmtDepartureDate.toLocaleDateString()) return true;

  return false;
};

export const cleanStateErrors = () => {
  const errorsDefault = {
    insuredForms: [
      {
        cpf: false,
        name: false,
        birth_date: false,
      },
    ],
    paymentMethods: false,
    creditCard: {
      cvv: false,
      number: false,
      parcels: false,
      card_brand: false,
      expiry_year: false,
      holder_name: false,
      holder_cpf: false,
      expiry_month: false,
    },
    boleto: {
      name: false,
      cpf: false,
    },
    safetypay: {
      cpf: false,
      name: false,
      banks: false,
      agency: false,
      account: false,
    },
    cash: {
      username: false,
      password: false,
    },
    pix: {
      name: false,
      cpf: false,
    },
    coupon: false,
    contact: {
      contact_name: false,
      email: false,
      phone_number: false,
    },
    purchase_is_valid: false,
    errorsModalFranchise: false,
  };

  return errorsDefault;
};

export const convertDate = (date) => {
  var parts = date.split('-');
  var mydate = new Date(parts[0], parts[1] - 1, parts[2]);
  var options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
  mydate = mydate.toLocaleDateString('pt-BR', options).split('de ');

  return mydate;
};

export const quotationDateYear = (beginDate, returnDate) => {
  const begin = new Date(beginDate);
  const dReturn = new Date(returnDate);
  const diff = Math.abs(begin.getTime() - dReturn.getTime());
  const days = Math.ceil(diff / (1000 * 60 * 60 * 24));

  if (days >= 365) {
    return true;
  }

  return false;
};

export const showDateVerbose = (date) => {
  var parts = '';
  var mydate = '';
  if (date.indexOf('/') > 0) {
    parts = date.split('/');
    mydate = new Date(parts[2], parts[1] - 1, parts[0]);
  } else {
    parts = date.split('-');
    mydate = new Date(parts[0], parts[1] - 1, parts[2]);
  }
  var options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
  mydate = mydate.toLocaleDateString('pt-BR', options).split('.').join('');
  if (mydate === 'Invalid Date') return '';
  return mydate.split('de ').join('');
};

export const HeaderAndFooterPayment = (location) => {
  const compHeader = document.getElementsByClassName('comp_header clearfixs');
  const compFooter = document.getElementsByClassName('comp_footer');

  if (compHeader.length > 0 && compFooter.length > 0) {
    if (location.indexOf('/pedido/') !== -1) {
      compHeader[0].classList.add('payment');
      compFooter[0].classList.add('payment');
    } else {
      compHeader[0].classList.remove('payment');
      compFooter[0].classList.remove('payment');
    }
  }
};

export const maxValueParcel = (plans) => {
  // 30.000 é o valor mínimo de cada parcela
  // 12 é a quantidade máxima de parcelas
  const new_plans_with_parcels = plans.map((plan, index) => {
    for (let i = 1; i <= 12; i += 1) {
      const parcelPrice = plan.adult.price / i;
      if (parcelPrice >= 30.0) plan.parcels = i;
    }

    return plan;
  });

  return new_plans_with_parcels;
};

export const getMaxParcel = (price) => {
  const minimalParcel = 30.0;

  if (price < minimalParcel * 2) {
    return 1;
  }

  let maxParcel = Math.floor(price / minimalParcel);

  if (maxParcel > 12) {
    maxParcel = 12;
  }

  return maxParcel;
};

export const dateFormatGMT = (date) => {
  var dateNew = new Date(date);

  return `${dateNew.getDate()}/${dateNew.getMonth() + 1}/${dateNew.getFullYear()}`;
};

export const getHoursDateGMT = (date) => {
  var dateNew = new Date(date);

  return `${dateNew.getHours()}:${dateNew.getMinutes() < 10 ? '0' + dateNew.getMinutes() : dateNew.getMinutes()}`;
};

export const getPurchasePending = (status) => status.indexOf('Pendente') !== -1;

export const isSelected = (config, currentValue = false) => {
  if (!!currentValue) return true;

  const screenSizeValid = window.innerWidth <= 768 ? false : true;
  return Boolean(screenSizeValid && config.selected);
};

export const validateTrackerModalOnBlur = (prospect, key) => {
  if (prospect[key] === '') {
    return ([key], 'Campo obrigatório');
  } else if (key === 'phone' && !isValidPhone(prospect[key])) {
    return ([key], 'Campo incorreto');
  } else if (key === 'email' && !isValidEmail(prospect[key])) {
    return ([key], 'Campo incorreto');
  } else if (key === 'name' && prospect[key].split(' ').length < 2) {
    return ([key], 'Digite o nome Completo');
  } else {
    return ([key], '');
  }
};

export const validateTrackerModal = (prospect) => {
  const errorName = validateTrackerModalOnBlur(prospect, 'name');
  const errorPhone = validateTrackerModalOnBlur(prospect, 'phone');
  const errorEmail = validateTrackerModalOnBlur(prospect, 'email');
  const valid = errorName === '' && errorPhone === '' && errorEmail === '';

  return {
    name: errorName,
    phone: errorPhone,
    email: errorEmail,
    isValid: valid,
  };
};

export const redirectToTracker = (destination, begin_date, end_date, prospect, coupon) => {
  setCookie('cupom', coupon, 1);
  let url =
    `/emitir-seguros/r/search?destination=${destination}` +
    `&coverageBegin=${begin_date}` +
    `&coverageEnd=${end_date}` +
    `&name=${prospect.name}` +
    `&email=${prospect.email}` +
    `&phone=${prospect.phone}`;
  console.log('Redirect to', url);
  window.location.href = url;
};

export const verifyOriginSearchUrl = (httpParams) => {
  httpParams = httpParams.replace('?', '').split('&');
  const filterParams = httpParams.filter((httpParam) => {
    let params = httpParam.split('=');
    if (params[0] === 'origin') {
      return params[1] === 'pp';
    }
  });
  return filterParams.length > 0;
};

export const getCupomInUrl = (httpParams) => {
  httpParams = httpParams.replace('?', '').split('&');

  let cupom = '';

  httpParams.filter((httpParams) => {
    let params = httpParams.split('=');
    if (params[0] === 'cupom') {
      return (cupom = params[1]);
    } else {
      cupom = 'PROMO15';
    }
  });

  return cupom;
};
export const getFilterSearchUrl = (httpParams) => {
  const categoryUrl = [];
  const providerUrl = [];

  httpParams = httpParams.replace('?', '').split('&');

  httpParams.map((param) => {
    if (param.search('category=') === 0) {
      categoryUrl.push(...param.replace('category=', '').split(','));
    }
    if (param.search('provider=') === 0) {
      providerUrl.push(...param.replace('provider=', '').split(','));
    }
  });

  return {
    categoryUrl,
    providerUrl,
  };
};

export const FormatCategoryName = (name) => {
  let newName = name.split(' ').join('-');
  return newName
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
};

const destinations = [
  { value: '1', name: 'Brasil', slug: 'brasil' },
  { value: '2', name: 'América do Sul', slug: 'america-do-sul' },
  { value: '3', name: 'Europa', slug: 'europa' },
  { value: '4', name: 'América do Norte', slug: 'america-do-norte' },
  { value: '5', name: 'América Central', slug: 'america-central' },
  { value: '6', name: 'Oceania', slug: 'oceania' },
  { value: '7', name: 'Oriente Médio', slug: 'oriente-medio' },
  { value: '8', name: 'Ásia', slug: 'asia' },
  { value: '9', name: 'África', slug: 'africa' },
  { value: '10', name: 'Marítimo', slug: 'maritimo' },
  { value: '11', name: 'Internacional', slug: 'internacional' },
  { value: '12', name: 'Brasil Receptivo', slug: 'brasil-receptivo' },
  { value: '13', name: 'Receptivo', slug: 'receptivo' },
  { value: '16', name: 'Argentina', slug: 'argentina' },
];

export const getDestinationSlugByName = (name) => {
  const destination = destinations.find((dest) => dest.name === name);
  return destination ? destination.slug : null;
};

export const getDestinationBySlug = (slugValue) => {
  const destination = destinations.find((dest) => dest.slug === slugValue);
  return destination ? destination.name : null;
};

export const buildSearchWithDestinationCategories = (destinationsList, destinationSlug) => {
  let search = window.location.search
    ? `?${window.location.search
        .replace('?', '')
        .split('&')
        .filter((param) => param && !param.startsWith('category='))
        .join('&')}`
    : '';
  if (search === '?') search = '';

  const selectedDestination = (destinationsList || []).find((d) => d.slug === destinationSlug);

  if (selectedDestination && selectedDestination.benefit_category_ids && selectedDestination.benefit_category_ids.length > 0) {
    const categoryParams = selectedDestination.benefit_category_ids.map((id) => `category=${id}`).join('&');
    search = search ? `${search}&${categoryParams}` : `?${categoryParams}`;
  }

  return search;
};

export const formatDateFromConvert = (date) => {
  const deadline_convert = date.split(/[-:]/);
  const deadline = `${deadline_convert[2]}-${deadline_convert[1]}-${deadline_convert[0]} ${deadline_convert[3]}:${deadline_convert[4]}:${deadline_convert[5]}`;

  return deadline;
};

export function deadlineForText(valor) {
  var hours = Math.floor(valor / 60); // Divide o valor total de minutos por 60 para obter as horas
  var minutes = valor % 60; // Usa o operador de módulo para obter os minutos restantes após a divisão por 60

  var text = '';
  if (hours > 0) {
    text += hours === 1 ? hours + ' hora' : hours + ' horas';
  }

  if (minutes > 0) {
    if (text.length > 0) {
      text += ' e ';
    }
    text += minutes === 1 ? minutes + ' minuto' : minutes + ' minutos';
  }

  if (text.length === 0) {
    text = '0 minutos';
  }

  return text;
}

export const normalizePaymentMethodsName = (name) => {
  switch (name) {
    case 'creditcard':
      return 'credit-card';
    case 'boleto':
      return 'boleto';
    case 'transfer':
      return 'safetypay';
    case 'cash':
      return 'cash';
    case 'pix':
      return 'pix';
    default:
      return '';
  }
};

export const cleanProviderName = (name) => {
  return name
    .split(' ')
    .join('-')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
};

export const fmtQueryParams = (queryParams) => {
  const params = new URLSearchParams(queryParams);

  const result = {};
  for (const [key, value] of params.entries()) {
    result[key] = value;
  }

  return result;
};

export const trackMatomoEvent = (category, action, name, value) => {
  if (window._paq) {
    const params = ['trackEvent', category, action, name];
    if (typeof value !== 'undefined' && value !== null && value !== '') {
      params.push(value);
    }
    window._paq.push(params);
  }
};

export const saveFilterToSession = (filterData) => {
  const existingFilters = getFiltersFromSession();
  const updatedFilters = [...existingFilters, filterData];
  sessionStorage.setItem('selectedFilters', JSON.stringify(updatedFilters));
};

export const getFiltersFromSession = () => {
  const filters = sessionStorage.getItem('selectedFilters');
  return filters ? JSON.parse(filters) : [];
};

export const clearFiltersFromSession = () => {
  sessionStorage.removeItem('selectedFilters');
};

export const formatDateToMonthYear = (dateString) => {
  const monthNames = [
    'janeiro',
    'fevereiro',
    'março',
    'abril',
    'maio',
    'junho',
    'julho',
    'agosto',
    'setembro',
    'outubro',
    'novembro',
    'dezembro',
  ];
  const dateObj = new Date(dateString);
  const month = monthNames[dateObj.getMonth()];
  const year = dateObj.getFullYear();
  return `${month}-${year}`;
};

export const getDaysInAdvance = (dateString) => {
  const today = new Date();
  const targetDate = new Date(dateString);
  return Math.floor((targetDate - today) / (1000 * 60 * 60 * 24));
};



// WEBPACK FOOTER //
// ./src/utils.js